export default __webpack_public_path__ + "static/media/signin-bg.796a5804.png";